import { create } from 'zustand';
import { fetchSiteCapabilities } from '../api/siteCapabilities';

type LoadStatus = 'idle' | 'loading' | 'ready';

interface SiteCapabilitiesState {
  status: LoadStatus;
  analyticsEnabled: boolean;
  load: () => Promise<void>;
  reset: () => void;
}

export const useSiteCapabilitiesStore = create<SiteCapabilitiesState>((set, get) => ({
  status: 'idle',
  analyticsEnabled: false,
  async load() {
    if (get().status === 'loading') return;
    set({ status: 'loading' });
    const capabilities = await fetchSiteCapabilities();
    set({
      status: 'ready',
      analyticsEnabled: capabilities.analyticsEnabled
    });
  },
  reset() {
    set({ status: 'idle', analyticsEnabled: false });
  }
}));
